













































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Sensor, Tank, TanksApi, Vat, VatsApi, VatState } from '@/api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
	components: {},
})
export default class VatCurrentStatus extends Vue {
	@Prop() public vat!: Vat & { sensors: Sensor[] };
	@Prop() public dash!: object;
	public vatState: any = {};

	public created() {
		this.loadCurrentState();
	}
	public goToSensor(...type: string[]) {
		const typeSensor = this.vat.sensors.filter(sensor => type.indexOf(sensor.type) != -1)[0];
		if (typeSensor) {
			this.$router.push({
				name: `sensors.view`,
				params: { sensorId: typeSensor.id },
			} as any);
		}
	}
	public async loadCurrentState() {
		try {
			const response = await new VatsApi().vatsVatIdCurrentStateGet(this.vat.id, {});
			// console.log( 'response', response);
			this.vatState = response.data.data;
		} catch (e) {
			console.log(e);
		}
	}
}
